import { useContext } from 'react'

import { Zoom } from './types'
import { ZoomContext } from './ZoomContext'

export const useZoom: () => Zoom = () => {
  return useContext(ZoomContext)
}
